export default __webpack_public_path__ + "static/singapore2-ce4f0a6c94d0eabd17825bc6ecad8040.gif";